module.exports = __webpack_public_path__ + "img/5-full-sm.8b50ae9b.jpg";